import React from 'react';
// Components
import AmaSalesReportTable from 'components/common/AmaSalesReportTable/AmaSalesReportTable';

const AmaSalesReport = (): JSX.Element => {
  return <AmaSalesReportTable />;
};

export default AmaSalesReport;
